export const selfSelector = (state) => state.push;